import { render } from "./UpwardGreenIcon.vue?vue&type=template&id=d8fbff36"
import script from "./UpwardGreenIcon.vue?vue&type=script&lang=js"
export * from "./UpwardGreenIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__